<template>
<div class="product-item" @click="gotoProductDetail">
  <div class="left-box">
    <div class="product-name">
      <div class="product-type" :style="{background: visaTypeMap[product.visa_type] ? visaTypeMap[product.visa_type].bgColor : visaTypeMap.qita.bgColor}">{{product.visa_type}}</div>
      <span class="name-text">{{ product.product_name_short }}</span>
    </div>
    <div class="other-info">
      <div class="other-info-item">
        <div class="item-label">入境次数</div>
        <el-tooltip
          v-if="product.entry_count_memo"
          effect="dark"
          :content="product.entry_count_memo"
          placement="top"
          popper-class="m-w-400"
        >
          <span v-html="entryCN"></span>
        </el-tooltip>
        <span v-else v-html="entryCN"></span>
      </div>
      <div class="other-info-item">
        <div class="item-label">有效期</div>
        <el-tooltip
          v-if="product.validity_period_memo"
          effect="dark"
          :content="product.validity_period_memo"
          placement="top"
          popper-class="m-w-400"
        >
          <span v-html="validityPeriodCN"></span>
        </el-tooltip>
        <span v-else v-html="validityPeriodCN"></span>
      </div>
    </div>
  </div>
  <div class="right-box">
    <div class="price-box">
      <!-- 是否有拒签无忧服务  0否 1是-->
      <div class="need-reject-label" v-if="product.need_reject_product && product.reject_product_set && product.reject_product_set.length"></div>
      <div
        v-if="product.special_price || product.after_coupon_price !== undefined"
        class="price-tag"
        :class="{
          'coupon': product.after_coupon_price !== undefined && product.available_coupon_info.coupon_type_id === 0,
          'new-people-coupon': product.after_coupon_price !== undefined && product.available_coupon_info.coupon_type_id === 1,
        }"
      ></div>

      <product-item-price-tips :product="product" :hide="!isLogin">
        <div class="price-num">
          <span class="currency">￥</span>
          <span class="price" v-if="isLogin">{{ productShowPrice }}</span>
          <span class="price" v-else>-</span>
        </div>
      </product-item-price-tips>
      
      <div v-if="!isLogin" class="login-btn" @click.stop="goToLogin">登录可见</div>
    </div>
    <div v-if="product.special_price || product.after_coupon_price !== undefined" class="original-price">
      <span class="origin-price-title">原价</span>
      <span class="origin-price-number">￥{{ product.peer_price / 100 }}</span>
    </div>
  </div>
</div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import { mapMutations } from 'vuex';
import User from '../../../libs/user';
import productService from '../../../services/product-service';
import sensorService from '../../../services/sensor-service';
import ProductItemPriceTips from './product-item-price-tips.vue';
import BasePopover from '@/components/common/popover/base-popover.vue';

export default {
  name: '',
  components: {
    ProductItemPriceTips,
    BasePopover,
  },
  props: {
    countryInfo: Object,
    product: Object,
    provinceCode: Number,
  },
  data() {
    return {
      visaTypeMap: {
        旅游签: { bgColor: 'linear-gradient(135deg,rgba(123,179,242,1) 0%,rgba(84,148,221,1) 100%)' },
        商务签: { bgColor: 'linear-gradient(135deg,rgba(94,211,187,1) 0%,rgba(61,187,162,1) 100%)' },
        探亲访友签: { bgColor: 'linear-gradient(135deg,rgba(161,154,223,1) 0%,rgba(130,122,202,1) 100%)' },
        短期学习签: { bgColor: 'linear-gradient(135deg,rgba(251,143,143,1) 0%,rgba(240,99,99,1) 100%)' },
        医疗签: { bgColor: 'linear-gradient(135deg,rgba(238,214,104,1) 0%,rgba(237,184,80,1) 100%)' },
        访问签: { bgColor: 'linear-gradient(135deg,rgba(116,208,247,1) 0%,rgba(72,185,233,1) 99%)' },
        免签: { bgColor: 'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)' },
        落地签: { bgColor: 'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)' },
        过境签: { bgColor: 'linear-gradient(135deg,rgba(132,218,228,1) 0%,rgba(87,198,211,1) 100%)' },
        香港L签过关服务: { bgColor: 'linear-gradient(135deg,rgba(162,221,141,1) 0%,rgba(129,196,106,1) 100%)' },
        入台证: { bgColor: 'linear-gradient(135deg,rgba(158,181,229,1) 0%,rgba(94,134,217,1) 100%)' },
        展会签: { bgColor: 'linear-gradient(135deg,rgba(217,179,140,1) 0%,rgba(180,144,106,1) 100%)' },
        EVUS登记: { bgColor: 'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)' },
        公证认证: { bgColor: 'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)' },
        公证: { bgColor: 'linear-gradient(135deg,rgba(132,218,228,1) 0%,rgba(87,198,211,1) 100%)' },
        签注续签: { bgColor: 'linear-gradient(135deg,rgba(162,221,141,1) 0%,rgba(129,196,106,1) 100%)' },
        '国际驾照（KIDA）': { bgColor: 'linear-gradient(135deg,rgba(158,181,229,1) 0%,rgba(94,134,217,1) 100%)' },
        香港驾照: { bgColor: 'linear-gradient(135deg,rgba(217,179,140,1) 0%,rgba(180,144,106,1) 100%)' },
        入金证: { bgColor: 'linear-gradient(135deg,rgba(252,187,131,1) 0%,rgba(237,148,71,1) 100%)' },
        香港签注续签: { bgColor: 'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)' },
        qita: { bgColor: 'linear-gradient(135deg,rgba(246,154,209,1) 0%,rgba(235,124,191,1) 100%)' }, // 此处故意用英文区分
      },
    };
  },
  computed: {
    isLogin() {
      return User.isLogin();
    },
    entryCN() {
      if (!this.product) return '';
      const cn = productService.getEntryCountCN(this.product.entry_count_n, this.product.entry_count_unit);
      // 需要把数字加粗，所以替换一下
      const reg = new RegExp('\\d+', 'g');
      return cn.replace(reg, text => `<span class="num">${text}</span>`);
    },
    validityPeriodCN() {
      if (!this.product) return '';
      const cn = productService.getValidityPeriodCN(this.product.validity_period_n, this.product.validity_period_unit);
      // 需要把数字加粗，所以替换一下
      const reg = new RegExp('\\d+', 'g');
      return cn.replace(reg, text => `<span class="num">${text}</span>`);
    },
    productShowPrice() {
      // if (!this.product) return '';
      // if (this.product.special_price !== undefined) {
      //   return this.product.special_price / 100;
      // } else if (this.product.after_coupon_price !== undefined) {
      //   return this.product.after_coupon_price / 100;
      // } 
      // return this.product.peer_price / 100;
      return productService.getSalesPrice(this.product);
    },
  },
  watch: {},
  created() {},
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    // 跳转到登录
    goToLogin() {
      this.SHOW_LOGIN_BOX();
    },
    gotoProductDetail() {
      sensorsdata.track('See_more', {
        country: this.countryInfo ? this.countryInfo.country : '',
        visa_type: this.product.visa_type,
        visa_product_id: this.product.visa_product_id,
      });
      // 商详神策埋点page_from字段
      const pageFrom = sensorService.getPageFrom();
      this.$router.push({ name: 'product', params: { visa_product_id: this.product.visa_product_id }, query: { province_code: this.provinceCode, ...pageFrom, countryId: this.countryInfo ? this.countryInfo.visa_country_id : '' } });
    },
  },
};
</script>

<style scoped lang="less">
.product-item {
  padding: 16px 42px;
  background: #fff;
  border-bottom: 1px solid #E9EEF2;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  &:last-child{
    border-bottom: none;
  }
  &:hover{
    background: rgba(89,159,255,0.08);
    &::before{
      content: "";
      width: 3px;
      height: 100%;
      background: #599FFF;
      position: absolute;
      left: 0;
      top: 0;
    }
    .left-box{
      .other-info {
        .other-info-item {
          color: #2F333D;
          /deep/ .num{
            color: #599FFF;
          }
        }
      }
    }
  }
  .left-box {
    flex-grow: 1;
    overflow: hidden;
    .product-name {
      color: #2F333D;
      font-size: 0;
      .product-type {
        height: 18px;
        padding: 0 4px;
        font-size: 12px;
        line-height: 1;
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-self: center;
        vertical-align: top;
        margin-top: 3px;
        margin-right: 4px;
        border-radius:1px;
      }

      .name-text {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
      }
    }

    .other-info {
      margin-top: 10px;
      display: flex;
      align-items: center;
      .other-info-item {
        color: #91999F;
        font-size: 12px;
        line-height: 1;
        margin-right: 16px;
        display: flex;
        align-items: center;
        .item-label{
          margin-right: 4px;
        }
        /deep/ .num{
          color: #5F666E;
        }
      }
    }
  }

  .right-box {
    flex-shrink: 0;
    margin-left: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .price-box {
      display: flex;
      align-items: center;
      .need-reject-label {
        width: 76px;
        height: 20px;
        margin-right: 4px;
        background: url(../../../assets/imgs/product-detail/visa-reject-refund-product.png) no-repeat center / 100% 100%;
      }
      .price-tag {
        width: 62px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin-right: 4px;
        background: url(../../../assets/imgs/product-detail/special-price-arrow-1.png) no-repeat center / 100% 100%;
        &.coupon{
          background: url(../../../assets/imgs/product-detail/special-price-coupon1.png) no-repeat center / 100% 100%;
          width: 98px;
        }
        &.new-people-coupon{
          background: url(../../../assets/imgs/product-detail/special-price-new-people-coupon1.png) no-repeat center / 100% 100%;
          width: 126px;
        }
        &.discount, &.free{
          background: url(../../../assets/imgs/product-detail/coupon-bg.png) no-repeat center / 100% 100%;
          // width: 126px;
          background-size: cover;
          padding: 0 4px;
          min-width: 90px;
          font-size: 14px;
          color: #fff;
        }
      }

      .price-num {
        display: flex;
        align-items: baseline;
        .currency {
          color: #FF8033;
          font-size: 18px;
          font-weight: 600;
        }

        .price {
          color: #FF8033;
          font-size: 24px;
          font-weight: 600;
        }
      }

      .login-btn {
        margin-left: 12px;
        width: 72px;
        height: 24px;
        border-radius: 1px;
        border: 1px solid #599FFF;
        color: #599FFF;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        line-height: 1;
      }
    }
    .original-price{
      margin-top: 6px;
      font-size: 12px;
      line-height: 1;
      color: #91999F;
      .origin-price-number{
        text-decoration: line-through;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/country/components/product-item.vue